import React from "react";
import { COLORS } from "../colors/colors";

export const TriangleIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    width?: number | string;
    height?: number | string;
    fill?: string;
  }
) => {
  const {
    width = "1.5rem",
    height = "1.5rem",
    fill = COLORS.IMMERSIVE_BLUE_DARK,
    ...svgProps
  } = props;
  return React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: width.toString(),
      height: height.toString(),
      viewBox: "0 0 24 24",
      fill: "none",
      style: {
        width: width,
        height: height,
        aspectRatio: "1/1",
        display: "block",
        ...(svgProps.style || {}),
      },
      ...svgProps,
    },
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.3969 20.6087L12 2.60071L1.6031 20.6087L22.3969 20.6087ZM13.3863 1.80035C12.7701 0.733214 11.2299 0.733216 10.6137 1.80036L0.216842 19.8083C-0.399271 20.8755 0.370872 22.2094 1.6031 22.2094H22.3969C23.6291 22.2094 24.3993 20.8755 23.7832 19.8083L13.3863 1.80035Z",
      fill: fill,
    })
  );
};

export const CircleIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    width?: number | string;
    height?: number | string;
    fill?: string;
  }
) => {
  const {
    width = "1.5rem",
    height = "1.5rem",
    fill = COLORS.IMMERSIVE_BLUE_DARK,
    ...svgProps
  } = props;
  return React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: width.toString(),
      height: height.toString(),
      viewBox: "0 0 24 24",
      fill: "none",
      style: {
        width: width,
        height: height,
        aspectRatio: "1/1",
        display: "block",
        ...(svgProps.style || {}),
      },
      ...svgProps,
    },
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 22C17.799 22 22 17.799 22 12C22 6.20101 17.799 2 12 2C6.20101 2 2 6.20101 2 12C2 17.799 6.20101 22 12 22ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
      fill: fill,
    })
  );
};

export const CrossIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    width?: number | string;
    height?: number | string;
    fill?: string;
  }
) => {
  const {
    width = "1.5rem",
    height = "1.5rem",
    fill = COLORS.IMMERSIVE_BLUE_DARK,
    ...svgProps
  } = props;
  return React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: width.toString(),
      height: height.toString(),
      viewBox: "0 0 24 24",
      fill: "none",
      style: {
        width: width,
        height: height,
        aspectRatio: "1/1",
        display: "block",
        ...(svgProps.style || {}),
      },
      ...svgProps,
    },
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.28033 0.21967C0.987438 -0.0732233 0.512564 -0.0732233 0.219671 0.21967C-0.0732221 0.512563 -0.0732221 0.987437 0.219671 1.28033L10.9393 12L0.21967 22.7197C-0.0732233 23.0126 -0.0732233 23.4874 0.21967 23.7803C0.512563 24.0732 0.987437 24.0732 1.28033 23.7803L12 13.0607L22.7197 23.7803C23.0126 24.0732 23.4874 24.0732 23.7803 23.7803C24.0732 23.4874 24.0732 23.0126 23.7803 22.7197L13.0607 12L23.7803 1.28033C24.0732 0.987439 24.0732 0.512565 23.7803 0.219672C23.4874 -0.0732215 23.0126 -0.0732212 22.7197 0.219672L12 10.9393L1.28033 0.21967Z",
      fill: fill,
    })
  );
};

export const BackArrowIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    width?: number | string;
    height?: number | string;
    fill?: string;
  }
) => {
  const {
    width = "0.8125rem",
    height = "1.25rem",
    fill = "#22404D",
    ...svgProps
  } = props;
  return React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: width.toString(),
      height: height.toString(),
      viewBox: "0 0 13 20",
      fill: "none",
      style: {
        width: width,
        height: height,
        display: "block",
        ...(svgProps.style || {}),
      },
      ...svgProps,
    },
    React.createElement("path", {
      d: "M1.86614 10.8069C1.37795 10.3606 1.37795 9.63584 1.86614 9.18956L9.36467 2.33471C9.85286 1.88843 10.6457 1.88843 11.1339 2.33471C11.622 2.78099 11.622 3.50575 11.1339 3.95203L4.51797 10L11.13 16.048C11.6181 16.4943 11.6181 17.219 11.13 17.6653C10.6418 18.1116 9.84896 18.1116 9.36077 17.6653L1.86223 10.8104L1.86614 10.8069Z",
      fill: fill,
    })
  );
};

export const ForwardArrowIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    width?: number | string;
    height?: number | string;
    fill?: string;
  }
) => {
  const {
    width = "0.625rem",
    height = "1rem",
    fill = "#22404D",
    ...svgProps
  } = props;
  return React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: width.toString(),
      height: height.toString(),
      viewBox: "0 0 10 16",
      fill: "none",
      style: {
        width: width,
        height: height,
        display: "block",
        ...(svgProps.style || {}),
      },
      ...svgProps,
    },
    React.createElement("path", {
      d: "M9.63386 8.80687C10.122 8.36059 10.122 7.63584 9.63386 7.18956L2.13533 0.33471C1.64714 -0.11157 0.854325 -0.11157 0.366139 0.33471C-0.122046 0.780989 -0.122046 1.50575 0.366139 1.95203L6.98203 8L0.370045 14.048C-0.118141 14.4943 -0.118141 15.219 0.370045 15.6653C0.858231 16.1116 1.65104 16.1116 2.13923 15.6653L9.63777 8.81044L9.63386 8.80687Z",
      fill: fill,
    })
  );
};

export const CloseIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    width?: number | string;
    height?: number | string;
    fill?: string;
  }
) => {
  const {
    width = "1rem",
    height = "1rem",
    fill = COLORS.IMMERSIVE_BLUE_DARK,
    ...svgProps
  } = props;

  return React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: width.toString(),
      height: height.toString(),
      viewBox: "0 0 16 16",
      fill: "none",
      style: {
        width: width,
        height: height,
        aspectRatio: "1/1",
        display: "block",
        ...(svgProps.style || {}),
      },
      ...svgProps,
    },
    React.createElement("path", {
      d: "M2.27724 0.394637C1.75661 -0.125993 0.911102 -0.125993 0.390472 0.394637C-0.130157 0.915267 -0.130157 1.76077 0.390472 2.2814L6.11324 8L0.394637 13.7228C-0.125992 14.2434 -0.125992 15.0889 0.394637 15.6095C0.915267 16.1302 1.76077 16.1302 2.2814 15.6095L8 9.88676L13.7228 15.6054C14.2434 16.126 15.0889 16.126 15.6095 15.6054C16.1302 15.0847 16.1302 14.2392 15.6095 13.7186L9.88676 8L15.6054 2.27724C16.126 1.75661 16.126 0.911102 15.6054 0.390472C15.0847 -0.130157 14.2392 -0.130157 13.7186 0.390472L8 6.11324L2.27724 0.394637Z",
      fill: fill,
    })
  );
};

export const ClosedDropdownArrowIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    width?: number | string;
    height?: number | string;
    fill?: string;
  }
) => {
  const {
    width = "1rem",
    height = "0.625rem",
    fill = "#22404D",
    ...svgProps
  } = props;

  return React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: width.toString(),
      height: height.toString(),
      viewBox: "0 0 16 10",
      fill: "none",
      style: {
        width: width,
        height: height,
        display: "block",
        ...(svgProps.style || {}),
      },
      ...svgProps,
    },
    React.createElement("path", {
      d: "M7.19313 9.63386C7.63941 10.122 8.36416 10.122 8.81044 9.63386L15.6653 2.13533C16.1116 1.64714 16.1116 0.854325 15.6653 0.366139C15.219 -0.122046 14.4943 -0.122046 14.048 0.366139L8 6.98203L1.95202 0.370045C1.50575 -0.118141 0.780988 -0.118141 0.334709 0.370045C-0.11157 0.858231 -0.11157 1.65104 0.334709 2.13923L7.18956 9.63777L7.19313 9.63386Z",
      fill: fill,
    })
  );
};

export const OpenedDropdownArrowIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    width?: number | string;
    height?: number | string;
    fill?: string;
  }
) => {
  const {
    width = "1rem",
    height = "0.625rem",
    fill = "#22404D",
    ...svgProps
  } = props;

  return React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: width.toString(),
      height: height.toString(),
      viewBox: "0 0 16 10",
      fill: "none",
      style: {
        width: width,
        height: height,
        display: "block",
        ...(svgProps.style || {}),
      },
      ...svgProps,
    },
    React.createElement("path", {
      d: "M7.19313 0.366138C7.63941 -0.122047 8.36416 -0.122047 8.81044 0.366138L15.6653 7.86467C16.1116 8.35286 16.1116 9.14567 15.6653 9.63386C15.219 10.122 14.4943 10.122 14.048 9.63386L8 3.01797L1.95202 9.62996C1.50575 10.1181 0.780988 10.1181 0.334709 9.62996C-0.11157 9.14177 -0.11157 8.34896 0.334709 7.86077L7.18956 0.362233L7.19313 0.366138Z",
      fill: fill,
    })
  );
};

export const SquareIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    width?: number | string;
    height?: number | string;
    fill?: string;
  }
) => {
  const {
    width = "1.5rem",
    height = "1.5rem",
    fill = COLORS.IMMERSIVE_BLUE_DARK,
    ...svgProps
  } = props;
  return React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: width.toString(),
      height: height.toString(),
      viewBox: "0 0 24 24",
      fill: "none",
      style: {
        width: width,
        height: height,
        aspectRatio: "1/1",
        display: "block",
        ...(svgProps.style || {}),
      },
      ...svgProps,
    },
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.75 1.5H2.25C1.83579 1.5 1.5 1.83579 1.5 2.25V21.75C1.5 22.1642 1.83579 22.5 2.25 22.5H21.75C22.1642 22.5 22.5 22.1642 22.5 21.75V2.25C22.5 1.83579 22.1642 1.5 21.75 1.5ZM2.25 0C1.00736 0 0 1.00736 0 2.25V21.75C0 22.9926 1.00736 24 2.25 24H21.75C22.9926 24 24 22.9926 24 21.75V2.25C24 1.00736 22.9926 0 21.75 0H2.25Z",
      fill: fill,
    })
  );
};

export const CheckmarkIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    width?: number | string;
    height?: number | string;
    fill?: string;
  }
) => {
  const {
    width = "18",
    height = "17",
    fill = COLORS.GRAY,
    ...svgProps
  } = props;
  return React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: width.toString(),
      height: height.toString(),
      viewBox: "0 0 18 17",
      fill: "none",
      style: {
        width: width,
        height: height,
        display: "block",
        ...(svgProps.style || {}),
      },
      ...svgProps,
    },
    React.createElement("path", {
      d: "M16.9834 0.242671C17.542 0.648921 17.667 1.43017 17.2607 1.98877L7.26074 15.7388C7.0459 16.0356 6.71387 16.2192 6.34668 16.2505C5.97949 16.2817 5.62402 16.145 5.36621 15.8872L0.366211 10.8872C-0.12207 10.3989 -0.12207 9.60595 0.366211 9.11767C0.854492 8.62939 1.64746 8.62939 2.13574 9.11767L6.10059 13.0825L15.2412 0.516109C15.6475 -0.0424852 16.4287 -0.167485 16.9873 0.238765L16.9834 0.242671Z",
      fill: fill,
    })
  );
};
